import modulesMap from 'core/modulesMap';
import Page from 'navigation/pages/Page';
class IframePage extends Page {
    getModulesMap() {
        return Object.assign({}, modulesMap);
    }
}
export default IframePage;
